import React from "react";

const Unauthorized = () => {
  return (
    <div><h2>You do not have permission to access this page.</h2></div>
  );
}

export default Unauthorized;